module.exports = __webpack_public_path__ + "static/img/player_head_11.1adbc7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_11.jpg
// module id = JZl3
// module chunks = 1